import {connect} from "react-redux";
import {
  getDropDownsList, 
  addDropDown, 
  updateDropDown, 
  deleteDropDown, 
} from '../actions/actions-drop-downs';
import {
  GET_GANGAFFILIATIONS_LIST
  , ADD_GANGAFFILIATION
  , UPDATE_GANGAFFILIATION
  , DELETE_GANGAFFILIATION
} from '../actions/action-constants';
import GangAffiliations from '../components/settings/gang-affiliations';
const mapStateToProps = (state, ownProps) => {
  return {
    gangaffiliations: state.gangaffiliationsR
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getGangAffiliations: (params) => {
      dispatch(getDropDownsList( params, GET_GANGAFFILIATIONS_LIST) );}
    , addGangAffiliation: (params) => {
      dispatch(addDropDown(params, ADD_GANGAFFILIATION)).then(() => dispatch(getDropDownsList( params, GET_GANGAFFILIATIONS_LIST) ) )  ;}
    , updateGangAffiliation: (id, params) => {
      dispatch(updateDropDown(id, params, UPDATE_GANGAFFILIATION)).then(() => dispatch(getDropDownsList( params, GET_GANGAFFILIATIONS_LIST) ) )  ;}
    , deleteGangAffiliation: (id, params) => {
      dispatch(deleteDropDown(id, params, DELETE_GANGAFFILIATION)).then(() => dispatch(getDropDownsList( params, GET_GANGAFFILIATIONS_LIST) ) )  ;}
  };
};
const GangAffiliationListContainer = connect(mapStateToProps, mapDispatchToProps)(GangAffiliations);
export default GangAffiliationListContainer;